module.exports = __webpack_public_path__ + "img/american-violence-3.0b050a29.png";